import Vue from 'vue'
import axios from 'axios'
import CONFIG from '~config/env'
import _ from 'lodash'
import { i18n } from '~src/i18n'

export const showApiError = error => {
  let errorMessage = ''
  const status = error.response?.status || 0
  const serverMessage = error.response?.data?.message || ''

  if (status === 403) {
    errorMessage = i18n.t('access_denied') + (serverMessage ? `: ${serverMessage}` : '')
  } else if (status === 404) {
    errorMessage = i18n.t('resource_not_found') + (serverMessage ? `: ${serverMessage}` : '')
  } else if (Math.round(status / 100) === 5) {
    errorMessage = serverMessage || i18n.t('server_error')
  } else if (status !== 400) {
    errorMessage = serverMessage || error.response?.data?.error || error.message
  }

  if (errorMessage) {
    Vue.toasted.error(i18n.t(errorMessage), {
      icon: 'error',
      className: 'subheading'
    })
  }
}

export const createApiClientInstance = () => {
  if (ApiClient) return
  const currentOrganization = Vue.currentOrganization
  if (_.isEmpty(currentOrganization)) return

  ApiClient = axios.create({
    baseURL: CONFIG.API.URL(),
    timeout: CONFIG.HTTP_TIMEOUT
  })
  ApiClient.interceptors.request.use(
    config => {
      const token = Vue.authToken
      if (token) config.headers.Authorization = 'token ' + token
      return config
    },
    _.throttle(error => {
      if (window.navigator.onLine) {
        showApiError(error)
      }
      return Promise.reject(error)
    }, 500)
  )

  ApiClient.interceptors.response.use(
    undefined,
    _.throttle(error => {
      if (window.navigator.onLine) {
        showApiError(error)
      }
      return Promise.reject(error)
    }, 500)
  )
}

export let ApiClient
